import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { PAReasonStop } from "./types";

export const paReasonStopListService = (params: {
  keyword?: string | null;
  code?: string | null;
  name?: string | null;
  page?: number | null;
  limit?: number | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAReasonStop>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paReasonStopListShortService = (params: {
  keyword?: string | null;
  code?: string | null;
  name?: string | null;
  page?: number | null;
  limit?: number | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAReasonStop>>({
    method: HTTPRequestMethods.GET,
    url: Paths.Short,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paReasonStopCreateService = (params: {
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  approve: boolean;
}) =>
  RestAPIClient.call<PAReasonStop>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paReasonStopUpdateService = ({
  id,
  ...rest
}: Parameters<typeof paReasonStopCreateService>[0] & {
  id: string;
  status?: number;
}) =>
  RestAPIClient.call<PAReasonStop>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${String(id)}`,
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const paReasonStopDetailService = (id: string) =>
  RestAPIClient.call<PAReasonStop>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const paReasonStopDeleteService = (id: string) =>
  RestAPIClient.call<PAReasonStop>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
